export const ACTION_ADD_PAGE__REQUEST = 'ACTION_ADD_PAGE__REQUEST';
export const ACTION_ADD_PAGE__SUCCESS = 'ACTION_ADD_PAGE__SUCCESS';
export const ACTION_ADD_PAGE__FAIL = 'ACTION_ADD_PAGE__FAIL';

export const ACTION_DELETE_PAGE__REQUEST = 'ACTION_DELETE_PAGE__REQUEST';
export const ACTION_DELETE_PAGE__SUCCESS = 'ACTION_DELETE_PAGE__SUCCESS';
export const ACTION_DELETE_PAGE__FAIL = 'ACTION_DELETE_PAGE__FAIL';

export const ACTION_ADD_PAGE_CONTENT__REQUEST = 'ACTION_ADD_PAGE_CONTENT__REQUEST';
export const ACTION_ADD_PAGE_CONTENT__SUCCESS = 'ACTION_ADD_PAGE_CONTENT__SUCCESS';
export const ACTION_ADD_PAGE_CONTENT__FAIL = 'ACTION_ADD_PAGE_CONTENT__FAIL';

export const ACTION_DELETE_PAGE_CONTENT__REQUEST = 'ACTION_DELETE_PAGE_CONTENT__REQUEST';
export const ACTION_DELETE_PAGE_CONTENT__SUCCESS = 'ACTION_DELETE_PAGE_CONTENT__SUCCESS';
export const ACTION_DELETE_PAGE_CONTENT__FAIL = 'ACTION_DELETE_PAGE_CONTENT__FAIL';

export const ACTION_EDIT_PAGE_CONTENT__REQUEST = 'ACTION_EDIT_PAGE_CONTENT__REQUEST';
export const ACTION_EDIT_PAGE_CONTENT__SUCCESS = 'ACTION_EDIT_PAGE_CONTENT__SUCCESS';
export const ACTION_EDIT_PAGE_CONTENT__FAIL = 'ACTION_EDIT_PAGE_CONTENT__FAIL';

export const ACTION_EDIT_PAGE_NAME__REQUEST = 'ACTION_EDIT_PAGE_NAME__REQUEST';
export const ACTION_EDIT_PAGE_NAME__SUCCESS = 'ACTION_EDIT_PAGE_NAME__SUCCESS';
export const ACTION_EDIT_PAGE_NAME__FAIL = 'ACTION_EDIT_PAGE_NAME__FAIL';

export const ACTION_LOAD_SITE_STATIC_PAGES__REQUEST = 'ACTION_LOAD_SITE_STATIC_PAGES__REQUEST';
export const ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS = 'ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS';
export const ACTION_LOAD_SITE_STATIC_PAGES__FAIL = 'ACTION_LOAD_SITE_STATIC_PAGES__FAIL';

export const ACTION_SET_PAGE_CONTENT_AVAILABILITY__REQUEST = 'ACTION_SET_PAGE_CONTENT_AVAILABILITY__REQUEST';
export const ACTION_SET_PAGE_CONTENT_AVAILABILITY__SUCCESS = 'ACTION_SET_PAGE_CONTENT_AVAILABILITY__SUCCESS';
export const ACTION_SET_PAGE_CONTENT_AVAILABILITY__FAIL = 'ACTION_SET_PAGE_CONTENT_AVAILABILITY__FAIL';

export const ACTION_SET_SITE_FOOTER_LINKS_PAGES = 'ACTION_SET_SITE_FOOTER_LINKS_PAGES';
export const ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT = 'ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT';
export const ACTION_SET_SITE_FOOTER_LINKS_PAGES_SORTED_IDS = 'ACTION_ADD_SITE_FOOTER_LINKS_PAGES_SORTED_IDS';
export const ACTION_SET_SITE_FOOTER_LINKS_LANGS = 'ACTION_SET_SITE_FOOTER_LINKS_LANGS';
export const ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES = 'ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES';
